import { observer } from 'mobx-react-lite'
import { WorkspacePostingDialogContainer } from '@/features/admin/staffing/components/WorkspacePostingDialog/WorkspacePostingDialogContainer'
import { type CreateWorkspacePostingDialogViewModel } from './CreateWorkspacePostingDialogViewModel'

export interface CreateWorkspacePostingDialogContainerProps {
  vm: CreateWorkspacePostingDialogViewModel
}

export const CreateWorkspacePostingDialogContainer = observer(
  function CreateWorkspacePostingDialogContainer({
    vm,
  }: CreateWorkspacePostingDialogContainerProps) {
    return (
      <WorkspacePostingDialogContainer
        vm={vm}
        title="New post"
        buttonText="Create Post"
      />
    )
  },
)
